// import api from '../api'

export const state = {
	companyTypeLoading: false,

	sessionType: [
		{ type: 'Research', content: 'Research' },
		{ type: 'Fitness', content: 'Fitness' },
		{ type: 'Corporate', content: 'Corporate' },
		{ type: 'Movie', content: 'Movie' },
		{ type: 'Music', content: 'Music' },
		{ type: 'Fitness2', content: 'Fitness II' },
		{ type: 'Detailed emotion', content: 'Detailed emotion' },
		{ type: 'Video', content: 'Video' }
	],
	sessionTypeLoading: false
}

export const mutations = {
	SET_COMPANY_TYPE_LOADING (state, payload) {
		this._vm.$set(state, 'companyTypeLoading', payload)
	},

	SET_SESSION_TYPE (state, payload) {
		this._vm.$set(state, 'sessionType', payload)
	},

	SET_SESSION_TYPE_LOADING (state, payload) {
		this._vm.$set(state, 'sessionTypeLoading', payload)
	}
}

export const actions = {
	// async getSessionType ({ commit }, payload) {
	// 	commit('SET_SESSION_TYPE_LOADING', true)
	// 	const { data, status } = await api('get', '/universal/session-type', payload)

	// 	if (status) commit('SET_SESSION_TYPE', data.data)
	// 	commit('SET_SESSION_TYPE_LOADING', false)
	// }
}

export const getters = {
}



// WEBPACK FOOTER //
// ./src/store/global/global.js